import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#020617] flex items-center justify-center" data-testid="not-found-page">
      <div className="text-center">
        <div className="text-8xl font-bold text-cyan-500/20 mb-4 font-mono">404</div>
        <h1 className="text-2xl font-bold text-white tracking-tight mb-2">Page Not Found</h1>
        <p className="text-sm text-slate-400 mb-8">The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/" className="inline-flex items-center gap-2 border border-cyan-500/50 bg-cyan-500/10 text-cyan-400 hover:bg-cyan-500 hover:text-black transition-all uppercase tracking-widest text-sm font-bold px-6 py-2.5" data-testid="back-home-btn">
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </Link>
      </div>
    </div>
  );
}
